<script setup lang="ts">
import IconRepeat from '@icons/ph_repeat.svg';
import { trans } from '../../../../_00_elements/translation';
import Icon from '../../../../_01_atoms/components/Icon.vue';

const props = withDefaults(defineProps<{
  type: string,
  isRecurring?: boolean,
}>(), {
  isRecurring: false,
});
</script>

<template>
  <div class="cell-flex">
    <template v-if="props.type === 'invoice'">
      <template v-if="props.isRecurring">
        <span class="invoice--recurring">
          <Icon :svg="IconRepeat" fill="black" />
        </span>

        {{ trans('gestion.invoices.type.recurring_invoice') }}
      </template>

      <template v-else>
        {{ trans('gestion.invoices.type.one_shot_invoice') }}
      </template>
    </template>

    <span v-else>
      {{ trans(`gestion.invoices.type.${props.type}`) }}
    </span>
  </div>
</template>
